import React, { useState } from "react";
import { Switch } from "@headlessui/react";

const InsuranceOptionsPage = ({ onNext, onBack, formData }) => {
  const [selectedInsurance, setSelectedInsurance] = useState({
    liability: true,
    waterSkiing: false,
    casco: false,
    cascoValue: "",
    trailerInsurance: false,
    trailerValue: "",
    dinghyInsurance: false,
    dinghyValue: "",
    trackAndTrace: false,
    rescueCosts: false,
    rescueAmount: "",
    personalAccidents: false,
    accidentPassengers: "",
    legalAssistance: false,
  });

  const [errors, setErrors] = useState({});
  const boatAge = new Date().getFullYear() - formData.boatYear;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSelectedInsurance((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const validate = () => {
    let validationErrors = {};
    if (selectedInsurance.casco && !selectedInsurance.cascoValue) {
      validationErrors.cascoValue = "Voer de waarde van het vaartuig in.";
    }
    if (selectedInsurance.rescueCosts && !selectedInsurance.rescueAmount) {
      validationErrors.rescueAmount =
        "Selecteer een bedrag voor lichtingskosten.";
    }
    if (selectedInsurance.dinghyInsurance && !selectedInsurance.dinghyValue) {
      validationErrors.dinghyValue = "Voer de waarde van de bijboot in.";
    }
    if (
      selectedInsurance.personalAccidents &&
      !selectedInsurance.accidentPassengers
    ) {
      validationErrors.accidentPassengers =
        "Selecteer het aantal passagiers voor de ongevallenverzekering.";
    }
    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };

  const handleNext = () => {
    if (validate()) {
      const updatedFormData = {
        ...formData, // Behoud bestaande formData
        selectedInsurance: selectedInsurance, // Voeg de geselecteerde verzekeringsopties toe
      };

      onNext(updatedFormData); // Stuur de bijgewerkte gegevens naar de volgende pagina
    }
  };

  console.log("Form Data bij Next:", formData.boatYear);

  return (
    <div className="p-8">
      <div className="mx-auto max-w-3xl p-6">
        <h1 className="text-3xl font-semibold mb-6 text-left text-[#1a2a6c]">
          Welke waarborgen wens je graag te onderschrijven?
        </h1>
        <p className="text-lg font-medium text-[#1a2a6c] mb-6">
          Laat ons weten welke waarborgen je graag wenst
        </p>
        <form className="space-y-6">
          {/* Liability (Verplicht) */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-0">
            <label className="text-lg font-semibold text-[#1a2a6c]">
              Burgerlijke aansprakelijkheid (verplicht)
            </label>
            <Switch
              checked={selectedInsurance.liability}
              onChange={() => {}}
              disabled
              className="bg-[#1a2a6c] ml-2 relative inline-flex h-6 w-11 items-center rounded-full transition-colors opacity-50"
            >
              <span className="translate-x-6 bg-[#ff6f61] inline-block h-4 w-4 transform rounded-full transition" />
            </Switch>
          </div>

          {/* Water Skiing */}
          {(formData.boatType === "RIB" ||
            formData.boatType === "Jetski" ||
            formData.boatType === "Motorboot") && (
            <>
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-0">
                <label className="text-lg font-semibold text-[#1a2a6c]">
                  Waterskiërs ook verzekeren?
                </label>
                <Switch
                  checked={selectedInsurance.waterSkiing}
                  onChange={(checked) =>
                    setSelectedInsurance({
                      ...selectedInsurance,
                      waterSkiing: checked,
                    })
                  }
                  className={`${
                    selectedInsurance.waterSkiing
                      ? "bg-[#1a2a6c]"
                      : "bg-gray-200"
                  } ml-2 relative inline-flex h-6 w-11 items-center rounded-full transition-colors`}
                >
                  <span
                    className={`${
                      selectedInsurance.waterSkiing
                        ? "translate-x-6 bg-[#ff6f61]"
                        : "translate-x-1 bg-white"
                    } inline-block h-4 w-4 transform rounded-full transition`}
                  />
                </Switch>
              </div>

              {selectedInsurance.waterSkiing && (
                <div className="mt-2">
                  <label
                    htmlFor="waterskiCapacity"
                    className="text-sm font-medium text-[#1a2a6c]"
                  >
                    Hoeveel mensen kun je voorttrekken?
                  </label>
                  <input
                    type="number"
                    id="waterskiCapacity"
                    name="waterskiCapacity"
                    value={selectedInsurance.waterskiCapacity}
                    onChange={(e) =>
                      setSelectedInsurance({
                        ...selectedInsurance,
                        waterskiCapacity: e.target.value,
                      })
                    }
                    className="mt-1 p-2 block w-full border border-[#ff6f61] rounded-md focus:ring-2 focus:ring-[#ff6f61]"
                  />
                </div>
              )}
            </>
          )}

          {/* Casco Insurance */}
          {boatAge <= 20 && (
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-0">
              <label className="text-lg font-semibold text-[#1a2a6c]">
                Wens je je boot ook in casco te verzekeren?
              </label>
              <Switch
                checked={selectedInsurance.casco}
                onChange={(checked) =>
                  setSelectedInsurance({ ...selectedInsurance, casco: checked })
                }
                className={`${
                  selectedInsurance.casco ? "bg-[#1a2a6c]" : "bg-gray-200"
                } ml-2 relative inline-flex h-6 w-11 items-center rounded-full transition-colors`}
              >
                <span
                  className={`${
                    selectedInsurance.casco
                      ? "translate-x-6 bg-[#ff6f61]"
                      : "translate-x-1 bg-white"
                  } inline-block h-4 w-4 transform rounded-full transition`}
                />
              </Switch>
            </div>
          )}
          {selectedInsurance.casco && (
            <ul className="mt-2 ml-6 list-disc space-y-1 text-sm text-[#1a2a6c] font-medium">
              <li>
                <label htmlFor="cascoValue" className="font-medium">
                  Actuele waarde van het vaartuig
                </label>
                <input
                  type="number"
                  id="cascoValue"
                  name="cascoValue"
                  value={selectedInsurance.cascoValue}
                  onChange={handleChange}
                  className={`mt-1 p-2 block w-full border ${
                    errors.cascoValue ? "border-red-500" : "border-[#ff6f61]"
                  } rounded-md focus:ring-2 focus:ring-[#ff6f61]`}
                />
                {errors.cascoValue && (
                  <p className="text-red-500 text-sm">{errors.cascoValue}</p>
                )}
              </li>
            </ul>
          )}

          {/* Rescue Costs Toggle */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-0">
            <label className="text-lg font-semibold text-[#1a2a6c]">
              Wens je lichtingskosten, hulp en berging te verzekeren?
            </label>
            <Switch
              checked={selectedInsurance.rescueCosts}
              onChange={(checked) =>
                setSelectedInsurance({
                  ...selectedInsurance,
                  rescueCosts: checked,
                })
              }
              className={`${
                selectedInsurance.rescueCosts ? "bg-[#1a2a6c]" : "bg-gray-200"
              } ml-2 relative inline-flex h-6 w-11 items-center rounded-full transition-colors`}
            >
              <span
                className={`${
                  selectedInsurance.rescueCosts
                    ? "translate-x-6 bg-[#ff6f61]" // Accent color when checked
                    : "translate-x-1 bg-white" // White when not checked
                } inline-block h-4 w-4 transform rounded-full transition`}
              />
            </Switch>
          </div>

          {selectedInsurance.rescueCosts && (
            <ul className="mt-2 ml-6 list-disc space-y-1 text-sm text-[#1a2a6c] font-medium">
              <li>
                <label htmlFor="rescueAmount" className="font-medium">
                  Selecteer een bedrag
                </label>
                <select
                  id="rescueAmount"
                  name="rescueAmount"
                  value={selectedInsurance.rescueAmount}
                  onChange={handleChange}
                  className={`mt-1 p-2 block w-full border ${
                    errors.rescueAmount ? "border-red-500" : "border-[#ff6f61]"
                  } rounded-md focus:ring-2 focus:ring-[#ff6f61]`}
                >
                  <option value="">Selecteer een bedrag</option>
                  <option value="25000">25.000 EUR</option>
                  <option value="45000">45.000 EUR</option>
                  <option value="75000">75.000 EUR</option>
                  <option value="custom">Op aanvraag</option>
                </select>
                {errors.rescueAmount && (
                  <p className="text-red-500 text-sm">{errors.rescueAmount}</p>
                )}
              </li>
            </ul>
          )}

          {/* Personal Accidents Toggle */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-0">
            <label className="text-lg font-semibold text-[#1a2a6c]">
              Wens je je passagiers ook voor persoonlijke ongevallen te
              verzekeren?
            </label>
            <Switch
              checked={selectedInsurance.personalAccidents}
              onChange={(checked) =>
                setSelectedInsurance({
                  ...selectedInsurance,
                  personalAccidents: checked,
                })
              }
              className={`${
                selectedInsurance.personalAccidents
                  ? "bg-[#1a2a6c]"
                  : "bg-gray-200"
              } ml-2 relative inline-flex h-6 w-11 items-center rounded-full transition-colors`}
            >
              <span
                className={`${
                  selectedInsurance.personalAccidents
                    ? "translate-x-6 bg-[#ff6f61]" // Accent color when checked
                    : "translate-x-1 bg-white" // White when not checked
                } inline-block h-4 w-4 transform rounded-full transition`}
              />
            </Switch>
          </div>

          {selectedInsurance.personalAccidents && (
            <ul className="mt-2 ml-6 list-disc space-y-1 text-sm text-[#1a2a6c] font-medium">
              <li>
                <label htmlFor="accidentPassengers" className="font-medium">
                  Selecteer aantal passagiers
                </label>
                <select
                  id="accidentPassengers"
                  name="accidentPassengers"
                  value={selectedInsurance.accidentPassengers}
                  onChange={handleChange}
                  className={`mt-1 p-2 block w-full border ${
                    errors.accidentPassengers
                      ? "border-red-500"
                      : "border-[#ff6f61]"
                  } rounded-md focus:ring-2 focus:ring-[#ff6f61]`}
                >
                  <option value="">Selecteer aantal passagiers</option>
                  <option value="5">5 passagiers</option>
                  <option value="10">10 passagiers</option>
                  <option value="15">15 passagiers</option>
                </select>
                {errors.accidentPassengers && (
                  <p className="text-red-500 text-sm">
                    {errors.accidentPassengers}
                  </p>
                )}
              </li>
            </ul>
          )}

          {/* Legal Assistance */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-0">
            <label className="text-lg font-semibold text-[#1a2a6c]">
              Wens je ook rechtsbijstand?
            </label>
            <Switch
              checked={selectedInsurance.legalAssistance}
              onChange={(checked) =>
                setSelectedInsurance({
                  ...selectedInsurance,
                  legalAssistance: checked,
                })
              }
              className={`${
                selectedInsurance.legalAssistance
                  ? "bg-[#1a2a6c]"
                  : "bg-gray-200"
              } ml-2 relative inline-flex h-6 w-11 items-center rounded-full transition-colors`}
            >
              <span
                className={`${
                  selectedInsurance.legalAssistance
                    ? "translate-x-6 bg-[#ff6f61]"
                    : "translate-x-1 bg-white"
                } inline-block h-4 w-4 transform rounded-full transition`}
              />
            </Switch>
          </div>

          <div className="flex justify-between mt-6 gap-4">
            <button
              type="button"
              onClick={onBack}
              className="w-auto py-2 px-4 bg-[#1a2a6c] text-[#ff6f61] rounded-md text-sm font-medium hover:bg-[#142057]"
            >
              Terug
            </button>
            <button
              type="button"
              onClick={handleNext}
              className="w-auto py-2 px-4 bg-[#1a2a6c] text-[#ff6f61] rounded-md text-sm font-medium hover:bg-[#142057]"
            >
              Volgende
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default InsuranceOptionsPage;
